var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.225 80.911)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.14-58.205h9.545a3.07,3.07,0,0,0,3.374-3.374v-8a4.046,4.046,0,0,0-1.268-3.4L21-76.808a4.051,4.051,0,0,0-3.363-1.268h-4.5a3.073,3.073,0,0,0-3.374,3.385v13.111A3.065,3.065,0,0,0,13.14-58.205Zm.408-2.887c-.623,0-.883-.306-.883-.894v-12.3c0-.6.26-.894.894-.894h3.148v3.793c0,1.834.86,2.683,2.695,2.683H23.16v6.714a.779.779,0,0,1-.894.894Zm6.035-9.873a.537.537,0,0,1-.611-.6v-3.487l4.065,4.087Zm.985,4.121H15.2a.619.619,0,0,0-.645.623.622.622,0,0,0,.645.634h5.367a.619.619,0,0,0,.634-.634A.617.617,0,0,0,20.567-66.844Zm0,2.548H15.2a.629.629,0,0,0-.645.634.619.619,0,0,0,.645.623h5.367a.617.617,0,0,0,.634-.623A.626.626,0,0,0,20.567-64.3Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentOutline);
export default __webpack_public_path__ + "static/media/documentOutline.19855babc2fce4c053a1b31e884034bd.svg";
export { ForwardRef as ReactComponent };